import React from 'react';
import { Modal } from 'antd';

const ConfirmationModal = ({ 
    isOpen, 
    onClose, 
    onConfirm, 
    title = 'Are you sure?', 
    content = 'This action cannot be undone.',
    okText = 'Yes',
    cancelText = 'No'
}) => {
    return (
        <Modal
            title={title}
            open={isOpen}
            onOk={onConfirm}
            onCancel={onClose}
            okText={okText}
            cancelText={cancelText}
        >
            <p>{content}</p>
        </Modal>
    );
};

export default ConfirmationModal; 
